export class FeatureFlag {
  static accessoryShop() {
    // @ts-ignore
    return Boolean(window.FeatureFlag.accessoryShop)
  }

  static hideStandaloneAccessoryShop() {
    // @ts-ignore
    return Boolean(window.FeatureFlag.hideStandaloneAccessoryShop)
  }
}
